<template>
    <div class="nav nav-tabs">
        <slot></slot>
    </div>
</template>
<script>
export default {
  name:'nav-tabs',
    props: {

    },
    mounted () {
    },
    render(h) {

    },
    computed:{

    },
    methods:{
        
    },
}
</script>
